<template>
   <header class="main-header">
      <div class="main-inner-header">
         <div class="header-botton">
            <div class="container">
               <nav class="navbar navbar-expand-lg" v-bind:class="{ 'navbarOpen': show }">
                  <div class="collapse navbar-collapse d-lg-none" id="navbarSupportedContent" v-bind:class="{ in: show }">
                     <div class="close-button">
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" id="navMobile"
                           data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                           aria-label="Toggle navigation" aria-expanded="false" @click="gotNav">
                           <span></span>
                           <span></span>
                           <span></span>
                        </button>
                     </div>
                     <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                           <div class="accordion" id="accordionPanelsStayOpenExample">
                              <div class="accordion-item">
                                 <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                    <button router-link to="#" class="nav-link accordion-button collapsed" type="button"
                                       data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-shop"
                                       aria-controls="panelsStayOpen-shop">
                                       Shop
                                    </button>
                                 </h2>
                                 <div id="panelsStayOpen-shop" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingOne">
                                    <div class="accordion-body">
                                       <div class="accordion" id="accordionPanelsStayOpenExample">
                                          <div class="accordion-item" v-for="(category, key) in categories" :key="key">
                                             <h2 class="accordion-header ct-acco-link d-flex align-items-center"
                                                id="panelsStayOpen-headingOne">
                                                <router-link :to="{ name: 'collection', params: { id: category.id } }"
                                                   class="header" @click="gotNav">
                                                   {{ category.name }}</router-link>
                                                <button class="accordion-button collapsed p-0 border-0" type="button"
                                                   data-bs-toggle="collapse" :data-bs-target="'#panelsStayOpen-singles-'+category.id"
                                                   aria-controls="panelsStayOpen-singles">
                                                </button>
                                             </h2>
                                             <div :id="'panelsStayOpen-singles-'+category.id" class="accordion-collapse collapse"
                                                aria-labelledby="panelsStayOpen-headingOne">
                                                <div class="accordion-body p-0">
                                                   <ul>
                                                      <li v-for="(product, key_product) in category.products"
                                                         :key="key_product">
                                                         <router-link :to="{ name: 'product', params: { id: product.id } }"
                                                         @click="gotNav">{{ product.name }}</router-link>
                                                      </li>
                                                   </ul>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </li>
                        <li class="nav-item dropdown">
                           <!-- <a href="/about" class="menu-maintitle nav-link">About</a> -->
                           <router-link to="/about" class="menu-maintitle nav-link"
                              @click="gotNav">About</router-link>
                        </li>
                        <li class="nav-item dropdown">
                           <router-link to="/faqs" class="menu-maintitle nav-link"
                           @click="gotNav">FAQs</router-link>
                        </li>
                        <li class="nav-item dropdown">
                           <router-link to="/contact" class="menu-maintitle nav-link"
                           @click="gotNav">Contact</router-link>
                        </li>
                     </ul>
                     <div class="nav-user">
                        <ul>
                           <li class="nav-user__item nav-user__item--account" v-if="!isLoggedIn">
                                 <router-link to="/login"  class="nav-user__link" @click="gotNav">Login</router-link>
                           </li>
                           <li class="nav-user__item nav-user__item--account" v-else>
                              <router-link to="/account"  class="nav-user__link" @click="gotNav">Account</router-link>
                           </li>
                           <li class="nav-user__item nav-user__item--search">
                              <router-link to="/search"  class="nav-user__link" @click="gotNav">Search</router-link>
                           </li>
                        </ul>
                     </div>
                     <div class="nav-footer">
                        <div class="nav-social">
                           <ul class="social-links social-links--nav">
                              <li>
                                 <a aria-label="Instagram" href="https://www.instagram.com/foodfoundry/" target="_blank"
                                    class="social-link">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"
                                       viewBox="0 0 1024 1024" class="icon icon-instagram">
                                       <path
                                          d="M511.839 0.323c-139.008 0-156.438 0.589-211.031 3.080-54.479 2.485-91.687 11.138-124.243 23.792-33.658 13.078-62.202 30.58-90.659 59.034-28.455 28.457-45.956 57.001-59.034 90.659-12.654 32.557-21.307 69.764-23.792 124.243-2.491 54.593-3.080 72.023-3.080 211.031 0 139.006 0.589 156.436 3.080 211.029 2.485 54.479 11.138 91.687 23.792 124.243 13.078 33.658 30.58 62.202 59.034 90.659 28.457 28.455 57.001 45.956 90.659 59.036 32.557 12.652 69.764 21.305 124.243 23.79 54.593 2.491 72.023 3.080 211.031 3.080 139.006 0 156.436-0.589 211.029-3.080 54.479-2.485 91.687-11.138 124.243-23.79 33.658-13.080 62.202-30.582 90.659-59.036 28.455-28.457 45.956-57.001 59.036-90.659 12.652-32.557 21.305-69.764 23.79-124.243 2.491-54.593 3.080-72.023 3.080-211.029 0-139.008-0.589-156.438-3.080-211.031-2.485-54.479-11.138-91.687-23.79-124.243-13.080-33.658-30.582-62.202-59.036-90.659-28.457-28.455-57.001-45.956-90.659-59.034-32.557-12.654-69.764-21.307-124.243-23.792-54.593-2.491-72.023-3.080-211.029-3.080zM511.839 92.546c136.665 0 152.854 0.522 206.826 2.985 49.904 2.276 77.005 10.614 95.041 17.623 23.891 9.285 40.942 20.376 58.852 38.288 17.912 17.91 29.003 34.96 38.288 58.852 7.010 18.036 15.348 45.137 17.623 95.041 2.462 53.971 2.985 70.16 2.985 206.828 0 136.665-0.522 152.854-2.985 206.826-2.276 49.904-10.614 77.005-17.623 95.041-9.285 23.891-20.376 40.942-38.288 58.852-17.91 17.912-34.96 29.003-58.852 38.288-18.036 7.010-45.137 15.348-95.041 17.623-53.963 2.462-70.15 2.985-206.826 2.985-136.678 0-152.862-0.522-206.828-2.985-49.904-2.276-77.005-10.614-95.041-17.623-23.891-9.285-40.942-20.376-58.852-38.288-17.91-17.91-29.003-34.96-38.288-58.852-7.010-18.036-15.348-45.137-17.623-95.041-2.462-53.971-2.985-70.16-2.985-206.826s0.522-152.856 2.985-206.828c2.276-49.904 10.614-77.005 17.623-95.041 9.285-23.891 20.376-40.942 38.288-58.852 17.91-17.912 34.96-29.003 58.852-38.288 18.036-7.010 45.137-15.348 95.041-17.623 53.971-2.462 70.16-2.985 206.828-2.985zM512.001 684.823c-95.449 0-172.824-77.375-172.824-172.822 0-95.449 77.375-172.824 172.824-172.824 95.447 0 172.822 77.375 172.822 172.824 0 95.447-77.375 172.822-172.822 172.822zM512.001 245.76c-147.042 0-266.241 119.199-266.241 266.241 0 147.040 119.199 266.239 266.241 266.239 147.040 0 266.239-119.199 266.239-266.239 0-147.042-119.199-266.241-266.239-266.241zM860.16 225.281c0 33.933-27.508 61.439-61.441 61.439-33.931 0-61.439-27.506-61.439-61.439s27.508-61.441 61.439-61.441c33.933 0 61.441 27.508 61.441 61.441z">
                                       </path>
                                    </svg>
                                 </a>
                              </li>
                           </ul>
                           <span tabindex="-1" class="last-focusable-element"></span>
                        </div>
                     </div>
                  </div>
               </nav>
            </div>
         </div>
      </div>
   </header>
</template>

<script>
export default {
   name: 'Headers-Mobile-Prismic',
   data() {
      return {
         categories: [],
         show: true,
      }
   },
   created() {
      this.getCategory();
   },
   computed: {
    isLoggedIn() {
      return this.$store.getters.GET_AUTH_STATUS
    },
  },
   methods: {
      getCategory() {
         this.$store.dispatch("SHOW_CATEGORY")
            .then((response) => {
               this.categories = response.data.categories;
            }).catch((err) => {
               console.log(err);
            });
      },
      toggleNavbar() {
         console.log("call here");
         this.show = !this.show;
      },
      gotNav(){
         this.toggleNavbar();
         document.querySelector(".navbar-toggler").click();
       }
   },

};


</script>


<style>
.ct-acco-link {
   padding: 12px 0 !important;
   border-bottom: 1px solid #e4e4e4;
}

.ct-acco-link a {
   font-size: 16px;
   color: #222222;
   width: 100%;
   font-weight: 400;
}

.navbar-expand-lg .navbar-collapse .accordion-body .ct-acco-link button.accordion-button {
   padding: 0 !important;
   border-bottom: 0 !important;
}

.navbar-expand-lg .navbar-collapse .accordion-body {
   padding-left: 38px;
}</style>
